import { List, Map } from 'immutable';

import * as types from './types';
import { types as activityTypes, constants as activityConstants, utils } from './../activity';


const initialState = new Map({
  group: null,
  loading: true,
  selectedTeams: new List(),
  teams: new List(),
  activity: [],
});

const groupDetailsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.INITIALIZE:
      return state.set('loading', false);
    case types.GROUP_GET.SUCCESS:
    case types.GROUP_UPDATE.SUCCESS:
      return state.withMutations((mutable) => {
        mutable.set('group', payload);
        if (payload.teams) {
          mutable.set('teams', new List(payload.teams));
        }
      });
    case types.GROUP_SET_CONCURRENCY.SUCCESS:
      return state.withMutations((mutable) => {
        const teams = state.get('teams');
        const newConcurrency = payload.virtual_machines_last_concurrency;

        mutable.update('group', (group) => ({
          ...group,
          virtual_machines_last_concurrency: newConcurrency,
        }));
        for (let i = 0; i < teams.size; i += 1) {
          mutable.updateIn(
            ['teams', i],
            (team) => ({
              ...team,
              settings: { ...team.settings, virtual_machines: newConcurrency },
            }),
          );
        }
        return mutable;
      });
    case types.TOGGLE_TEAM_SELECTION: {
      const id = payload.id.toString();
      const selectedTeams = state.get('selectedTeams');
      const index = selectedTeams.indexOf(id);
      if (index >= 0) {
        return state.set('selectedTeams', selectedTeams.delete(index));
      }
      return state.set('selectedTeams', selectedTeams.push(id));
    }
    case types.CLEANUP:
      return initialState;
    case types.TEAM_REMOVE_FROM_GROUP.SUCCESS: {
      return state.withMutations((mutable) => {
        const teamsIndex = state.get('teams').findIndex((team) => (
          team.id === payload.teamId.toString()
        ));
        const selectedTeamsIndex = state.get('selectedTeams').findIndex((id) => (
          id === payload.teamId.toString()
        ));

        return mutable
          .deleteIn(['teams', teamsIndex])
          .deleteIn(['selectedTeams', selectedTeamsIndex]);
      });
    }
    case activityTypes.GET_GROUPS_ACTIVITY.SUCCESS: {
      const group = state.get('group');
      if (!group) return state;
      return state.withMutations((mutable) => {
        Object
          .entries(payload)
          .forEach(([groupId, value]) => {
            if (group.id !== groupId) {
              return;
            }

            const data = utils.serializeMultiActivityData(value,
              activityConstants.CHARTS_DATA_PERIOD,
              activityConstants.CHARTS_NUMBER_OF_PERIODS,
            );

            mutable.set('activity', data);
          });
      });
    }
    default:
      return state;
  }
};

export default groupDetailsReducer;
